import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { EffectsModule } from '@ngrx/effects';
import { SimplebarAngularModule } from 'simplebar-angular';
import { NewDocumentViewMenu } from '../components/templates/new-document-view/new-document-view.module';
import { TextareaModule } from '../components/templates/textarea/textarea.module';
import { CustomFormsModule } from '../custom-forms-module/custom-forms.module';
import { ContractGroupTypeEffects } from '../dave-data-module/State/effects/mdqx/contract-group-type.effects';
import { ContractOptionsEffects } from '../dave-data-module/State/effects/mdqx/contract-options.effects';
import { ContractParticipantEffects } from '../dave-data-module/State/effects/mdqx/contract-participant.effects';
import { ContractPartnerEffects } from '../dave-data-module/State/effects/mdqx/contract-partner.effects';
import { ContractStatusEffects } from '../dave-data-module/State/effects/mdqx/contract-status.effects';
import { ContractEffects } from '../dave-data-module/State/effects/mdqx/contract.effects';
import { Contract2DiagnosesicherheitEffects } from '../dave-data-module/State/effects/mdqx/contract2diagnosesicherheit.effects';
import { Contract2FachbereichEffects } from '../dave-data-module/State/effects/mdqx/contract2fachbereich.effects';
import { Contract2PlausibilitaetEffects } from '../dave-data-module/State/effects/mdqx/contract2plausibilitaet.effects';
import { CustomerOptionsEffects } from '../dave-data-module/State/effects/mdqx/customer-options.effects';
import { DiagnosesicherheitEffects } from '../dave-data-module/State/effects/mdqx/diagnosesicherheit.effects';
import { DoctorCatalogEffects } from '../dave-data-module/State/effects/mdqx/doctor/doctor-catalog.effects';
import { DoctorEffects } from '../dave-data-module/State/effects/mdqx/doctor/doctor.effects';
import { MembershipEffects } from '../dave-data-module/State/effects/mdqx/doctor/membership.effects';
import { QualificationEffects } from '../dave-data-module/State/effects/mdqx/doctor/qualification.effects';
import { TypeOfTreatmentEffects } from '../dave-data-module/State/effects/mdqx/doctor/type-of-treatment.effects';
import { FachbereichEffects } from '../dave-data-module/State/effects/mdqx/fachbereich.effects';
import { PlausibilitaetEffects } from '../dave-data-module/State/effects/mdqx/plausibilitaet.effects';
import { PracticeTypeEffects } from '../dave-data-module/State/effects/mdqx/practice-type.effects';
import { SpezifikationEffects } from '../dave-data-module/State/effects/mdqx/spezifikation.effects';
import { SpezifikationsArtEffects } from '../dave-data-module/State/effects/mdqx/spezifikations-art.effects';
import { TEGueltigkeitEffects } from '../dave-data-module/State/effects/mdqx/te-gueltigkeit.effects';
import { PreviewModule } from '../dave-dms-module/dave-dms/preview/preview.module';
import { DaveDoubleIconModule } from '../dave-double-icon/dave-double-icon.module';
import { DaveFileExplorerModule } from '../dave-file-explorer/dave-file-explorer.module';
import { DaveHistoryModule } from '../dave-history-module/dave-history.module';
import { DaveListCardModule } from '../dave-list-card/dave-list-card.module';
import { DaveLoadingModule } from '../dave-loading/dave-loading.module';
import {
SelectCustomerComponent
} from '../dave-select-user/components/select-user-dialogs/select-customer/select-customer.component';
import { DaveSelectUserModule } from '../dave-select-user/dave-select-user.module';
import { AppButtonModule } from '../dave-utils-module/app-button-module/app-button.module';
import { AppFilterModule } from '../dave-utils-module/app-filter-module/app-filter.module';
import { DaveSharedComponentsModule } from '../dave-utils-module/dave-shared-components-module/dave-shared-components.module';
import { LengthPipe } from '../helper/length.pipe';
import { AdditionalCustomerOptionsComponent } from './components/additional-customer-options/additional-customer-options.component';
import { CustomerContractListCardComponent } from './components/customer-contract-list-card/customer-contract-list-card.component';
import { SelectContractPopupComponent } from './components/customer-contract-list-card/select-contract-popup/select-contract-popup.component';
import { ContractListComponent } from './components/contract/contract-list/contract-list.component';
import { ContractComponent } from './components/contract/contract.component';
import { DetailContractComponent } from './components/contract/detail-contract/detail-contract.component';
import { NewContractComponent } from './components/contract/new-contract/new-contract.component';
import { SelectCustomersForContractDialogComponent } from './components/contract/select-customers-for-contract-dialog/select-customers-for-contract-dialog.component';
import { DeletedDialogComponent } from './components/deleted-dialog/deleted-dialog.component';
import { DetailFilterComponent } from './components/detail-filter/detail-filter.component';
import { DoctorListCardComponent } from './components/doctor-list-card/doctor-list-card.component';
import { MdqxContractsRoutingModule } from './mdqx-contracts.routing.module';
import { Customer2QualificationEffects } from '../dave-data-module/State/effects/mdqx/custommer2qualification.effects';
import { ServiceGroupEffects } from '../dave-data-module/State/effects/mdqx/doctor/service-group.effects';

@NgModule({
    declarations: [
        NewContractComponent,
        ContractComponent,
        DetailContractComponent,
        DeletedDialogComponent,
        ContractListComponent,
        SelectCustomersForContractDialogComponent,
        DetailFilterComponent,
        CustomerContractListCardComponent,
        DoctorListCardComponent,
        AdditionalCustomerOptionsComponent,
        SelectContractPopupComponent,
    ],
    imports: [
        CommonModule,
        MdqxContractsRoutingModule,
        EffectsModule.forFeature([
            ContractEffects,
            Contract2DiagnosesicherheitEffects,
            Contract2FachbereichEffects,
            Contract2PlausibilitaetEffects,
            ContractGroupTypeEffects,
            ContractOptionsEffects,
            ContractParticipantEffects,
            ContractPartnerEffects,
            ContractStatusEffects,
            CustomerOptionsEffects,
            DiagnosesicherheitEffects,
            DoctorEffects,
            FachbereichEffects,
            PlausibilitaetEffects,
            PracticeTypeEffects,
            SpezifikationEffects,
            SpezifikationsArtEffects,
            TEGueltigkeitEffects,
            QualificationEffects,
            MembershipEffects,
            DoctorCatalogEffects,
            TypeOfTreatmentEffects,
            Customer2QualificationEffects,
            ServiceGroupEffects
        ]),
        MatDialogModule,
        AppButtonModule,
        DaveSharedComponentsModule,
        SimplebarAngularModule,
        MatCardModule,
        MatFormFieldModule,
        MatSelectModule,
        ReactiveFormsModule,
        FontAwesomeModule,
        DaveHistoryModule,
        MatListModule,
        RouterModule,
        MatToolbarModule,
        MatInputModule,
        MatButtonModule,
        MatTooltipModule,
        MatTableModule,
        MatSortModule,
        DaveFileExplorerModule,
        NewDocumentViewMenu,
        PreviewModule,
        TextareaModule,
        DaveLoadingModule,
        CustomFormsModule,
        SelectCustomerComponent,
        AppFilterModule,
        DaveSelectUserModule,
        MatBadgeModule,
        DaveDoubleIconModule,
        DaveListCardModule,
        LengthPipe,
    ],
    exports: [CustomerContractListCardComponent, AdditionalCustomerOptionsComponent, DoctorListCardComponent],
})
export class MdqxContractsModule {}
